<div [class]="classPrefix('MainPod')">
  <h2 [ngStyle]="props.title.style">{{props.title.text | translate}}</h2>
  <h3 [class]="classPrefix('MainText0')" [ngStyle]="props.subtitle.style">{{props.subtitle.text | translate}}</h3>
  <wml-options-zero
  [class]="classPrefix('MainItem0')"
  [props]="props.options"></wml-options-zero>
</div>
